import React from 'react'

import Section from 'components/Section'
import { useMobile } from 'hooks/ua'

import styles from './style.less'

import pcBg from './images/pcBg.png'
import mobileBg from './images/mobileBg.png'

export default function Intro() {
  const isMobile = useMobile()

  return (
    <Section name="intro" title="加入 NiuLink，获得稳定收益" subtitle="只要您有移动、联通、电信任一运营商带宽资源，欢迎加入 NiuLink，每月获取稳定收益" grey={false} className={styles.wrap}>
      <img src={isMobile ? mobileBg : pcBg} className={styles.img} />
    </Section>
  )
}
